module.exports = __webpack_public_path__ + "static/media/FCPSR_B.e3e8992d.svg";